var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 98,
    viewBox: "0 0 120 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.348 0.00195312L119.348 97.0215L70.8379 48.5117L70.8379 0.00194888L119.348 0.00195312Z",
    fill: "#024AFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5117 0L48.5117 97.0195L0.00196414 48.5097L0.00196838 -4.24086e-06L48.5117 0Z",
    fill: "#024AFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuote);
export default __webpack_public_path__ + "static/media/icon_quote.71fbb46a9068a20cf944db0baa51074b.svg";
export { ForwardRef as ReactComponent };